import React, { Component } from "react";

const mainStyle = {
  marginTop: 10
};

const titleStyle = {
  verticalAlign: "top",
  fontWeight: 500,
  fontSize: "30px",
  color: "#0e2f5a",
  textAlign: "center"
};

class AppHeader extends Component {
  render() {
    return (
      <div style={{ textAlign: "center" }}>
        <div style={mainStyle}>
          <img src="/Readymode_(R)_Combination Mark_Horizontal_Navy.png" height="50" alt=""></img>
          <br />
          Readymode billing portal, pay portal for Readymode client access
        </div>
      </div>
    );
  }
}

export { AppHeader };
